import { Navigate } from "@solidjs/router";

export function ScanJourneys(props: { websiteId: string }) {
  return <Navigate href={`/w/${props.websiteId}/scan/pages?view=paths`} />;
}
